import React, { useState, useEffect } from "react";
import "react-datepicker/dist/react-datepicker.css";
import Confirm from "../images/blue-tick-success.png";
import Auto from "../images/tpl/Icons-04.png";
import Bike from "../images/tpl/Icons-08.png";
import FWMobile from "../images/mobile-mockup.png";
import GooglePlay from "../images/google-play-badge.png";
import AppleStore from "../images/app-store.jpg";
import EasyReport from "../images/checke.png";
import axios from "axios";
import { baseUrl } from "../api/ipconfig";
import { Modal, Box, Button } from "@mui/material";
import { useHistory } from "react-router-dom";

export default function TplInsurance() {
  const history = useHistory();

  const [vehicleType, setVehicleType] = useState("");
  const [make, setMake] = useState(null);
  const [makeName, setMakeName] = useState(null);
  const [modelName, setModelName] = useState(null);
  const [yearName, setYearName] = useState(null);
  const [makeId, setMakeId] = useState("");
  const [modelId, setModelId] = useState("");
  const [yearId, setYearId] = useState("");
  const [modelYear, setModelYear] = useState(null);
  const [getModel, setGetModel] = useState(null);
  const [isOpen, setIsOpen] = useState(false);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [type, setType] = useState("");
  const [successOpen, setSuccessOpen] = useState(false);

  useEffect(() => {
    const fetchMake = async () => {
      try {
        const response = await axios.get(`${baseUrl}/byMake`);
        setMake(response.data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchMake();
  }, []);

  const handleMakeChange = (e) => {
    const selectedMake = make?.find((item) => item.makeName === e.target.value);
    if (selectedMake) {
      setMakeId(selectedMake.makeId);
    } else {
      setMakeId("");
    }
    setMakeName(e.target.value);
  };

  const handleModelChange = (e) => {
    const selectedModel = getModel.find(
      (item) => item.modelName === e.target.value
    );
    if (selectedModel) {
      setModelId(selectedModel.modelId);
    } else {
      setModelId("");
    }
    setModelName(e.target.value);
  };

  const handleYearChange = (e) => {
    const selectedYear = modelYear.find((item) => item.year === e.target.value);
    if (selectedYear) {
      setYearId(selectedYear.yearId);
    } else {
      setYearId("");
    }
    setYearName(e.target.value);
  };

  // all models api

  useEffect(() => {
    const fetchModel = async () => {
      try {
        const response = await axios.get(
          `${baseUrl}/model-by-make?make_id=${makeId}`
        );

        setGetModel(response.data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    if (makeId) {
      fetchModel();
    } else {
      setGetModel([]);
    }
  }, [makeId]);

  // all years api

  useEffect(() => {
    const fetchYear = async () => {
      try {
        const response = await axios.get(`${baseUrl}/getModelYear`);

        setModelYear(response.data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchYear();
  }, []);

  const onClose = () => {
    setIsOpen(false);
    setMakeName(null);
    setModelName(null);
    setYearName(null);
    setMakeId("");
    setGetModel(null);
  };

  const handleConfirmVehicle = () => {
    setIsOpen(false);
    setVehicleType(`${makeName} ${modelName} ${yearName}`);
  };

  const handleSubmitInfo = async (e) => {
    e.preventDefault();
    try {
      const formData = new FormData();

      formData.append("insuranserequest_name", name);
      formData.append("insuranserequest_email", email);
      formData.append("insuranserequest_phone", phone);
      formData.append("insuranserequest_insurance", type);
      formData.append("make_id", makeId);
      formData.append("model_id", modelId);
      formData.append("year_id", yearId);

      const response = await axios.post(
        `${baseUrl}/saveinsuranserequest`,
        formData
      );
      setSuccessOpen(true);

      setTimeout(() => {
        setSuccessOpen(false);
        history.push("/");
      }, 2000);
    } catch (err) {
      console.error(err.response);
    }
  };
  return (
    <>
      <div
        style={{ paddingTop: "10%" }}
        className="container-fluid newColorGrad_bg pb-5 "
      >
        <div className="container pb-0 pb-md-4 ">
          <div className="row align-items-center flex-column-reverse flex-md-row ">
            <div className="carFinanceLeft col-lg-7 col-12 text-white text-start ">
              <img
                style={{
                  width: "60%",
                }}
                className="  img-fluid "
                src="https://cometinsure.com/pk/images/company/tpl.png"
                alt="Car Insurance"
              />

              <p className="py-4 textSmallFinance">
                We protect your assets by capitalizing on cutting-edge
                technology, backed by
                <br />
                24x7 customer services, catering to your needs anytime,
                anywhere.
              </p>
            </div>
            <div className="col-lg-5 col-12 mb-5 mb-md-0 ">
              <div className="inspectionFormbox px-4 py-5 ">
                <div>
                  <h4 className="text-white fw-bold text-center pb-3 fs-4">
                    Get a Quote
                  </h4>
                </div>
                <form className=" postAdForm" onSubmit={handleSubmitInfo}>
                  <div className="row mb-3">
                    <div className="mb-3">
                      <input
                        type="text"
                        className="form-control"
                        id="inspectionVehicle"
                        aria-describedby="inspectionVehicleHelp"
                        placeholder="Select car brand"
                        required
                        value={vehicleType}
                        onClick={() => setIsOpen(true)}
                        readOnly
                      />
                    </div>
                    <div className="col-12 col-4">
                      <div className="mb-3">
                        <input
                          type="text"
                          className="form-control"
                          id="inspectionVehicle"
                          aria-describedby="inspectionVehicleHelp"
                          placeholder="Your Name"
                          required
                          value={name}
                          onChange={(e) => setName(e.target.value)}
                        />
                      </div>
                    </div>
                    <div className="col-12 col-4">
                      <div className="mb-3">
                        <input
                          type="number"
                          className="form-control"
                          id="inspectionVehicle"
                          aria-describedby="inspectionVehicleHelp"
                          placeholder="Your Phone"
                          required
                          value={phone}
                          onChange={(e) => setPhone(e.target.value)}
                        />
                      </div>
                    </div>
                    <div className="col-12 col-4">
                      <div className="mb-3">
                        <input
                          type="email"
                          className="form-control"
                          id="inspectionVehicle"
                          aria-describedby="inspectionVehicleHelp"
                          placeholder="You Email"
                          required
                          value={email}
                          onChange={(e) => setEmail(e.target.value)}
                        />
                      </div>
                    </div>
                    <div className="col-12 col-4">
                      <div className="mb-3">
                        <select
                          className="form-select"
                          id="inspectionVehicle"
                          aria-describedby="inspectionVehicleHelp"
                          required
                          value={type}
                          onChange={(e) => setType(e.target.value)}
                        >
                          <option value="" disabled selected>
                            Select Insurance
                          </option>
                          <option value="Auto Insurance">Auto Insurance</option>
                          <option value="Bike Insurance">Bike Insurance</option>
                        </select>
                      </div>
                    </div>

                    <button
                      type="submit"
                      className="btn card_Shadow fw-600 w-100 mt-3 p-sm-3 p-2 financeInput bgSecondary text-white"
                    >
                      Submit
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="container py-5">
        <div className="container">
          <h4 className="fw-700 text-center color-secondary fs-2 pt-3 pb-4">
            About TPL
          </h4>
          <div className="col-sm-12">
            <p>
              TPL Insurance (TPLI) is a pioneer in seamless insurance services
              in Pakistan, through state-of-the-art Insurtech infrastructure and
              a 24/7 Contact Center. TPLI offers all lines of General Insurance
              including Auto, Fire, Marine, Health, Home, Travel, Mobile, Cyber
              Risk, Engineering and Agriculture, with both Conventional and
              Takaful (Islamic) solutions for its customers. The reinsurance
              treaties are managed with leading reinsurers such as Hannover Re
              and IFS rating of the company issued by PACRA is AA. TPLI has
              disrupted the existing insurance ecosystem by servicing and
              delivering exceptional value to customers through integrations
              with multiple business partners, spanning startups and established
              players.
            </p>
            <p>
              TPL Insurance is also the first player in the insurance industry
              to launch Buy Now, Pay Later (BNPL) Auto Insurance with easy
              monthly installments on 3 or 6 months and zero interest rate to
              facilitate its customers.
            </p>
            <p>
              TPLI became the 1st Insurer in Pakistan with their presence in the
              Metaverse, whereby focusing on the next generation of its
              customers. Users can virtually meet, greet and discuss their
              insurance needs and experiences. Users can also learn about our
              products or latest offers as they walk around in our Metaverse
              gallery. In upcoming months, we are focusing on issuing policies
              and providing services to everyone virtually to make it easier for
              the customers to avail all benefits.
            </p>
          </div>
        </div>
        <h4 className="fw-700 text-center color-secondary fs-2 pt-3 pb-4">
          Comprehensive Insurance Plan
        </h4>
        <div className="container pb-3">
          <div className="row pb-5 justify-content-center">
            <div className="col-lg-3 col-6  d-flex justify-content-center align-items-center ">
              <div className="StepperCount">01</div>
              <div className="OurSteppers">
                <img src={EasyReport} alt="Easy Report" srcSet={EasyReport} />

                <h6 className="text-capitalize ">Comprehensive Plan</h6>
              </div>
            </div>

            <div className="col-lg-3 col-6 d-flex justify-content-center align-items-center ">
              <div className="StepperCount">02</div>
              <div className="OurSteppers">
                <img src={EasyReport} alt="Easy Report" srcSet={EasyReport} />

                <h6 className="text-capitalize ">5T Coverage</h6>
              </div>
            </div>

            <div className="col-lg-3 col-6 d-flex justify-content-center align-items-center ">
              <div className="StepperCount">03</div>
              <div className="OurSteppers">
                <img src={EasyReport} alt="Easy Report" srcSet={EasyReport} />

                <h6 className="text-capitalize ">Kar4Kar</h6>
              </div>
            </div>
            <div className="col-lg-3 col-6 d-flex justify-content-center align-items-center ">
              <div className="StepperCount">04</div>
              <div className="OurSteppers">
                <img src={EasyReport} alt="Easy Report" srcSet={EasyReport} />

                <h6 className="text-capitalize ">3T Policy</h6>
              </div>
            </div>
          </div>
        </div>

        <div className="row justify-content-center">
          <div className="col-lg-4 col-md-4 col-12 p-2 d-flex flex-column px-5 px-md-3 mt-4   ">
            <div className=" d-flex justify-content-center">
              <img
                width={80}
                height={80}
                src={Auto}
                alt="step 3"
                srcSet={Auto}
              />
            </div>
            <div className="ms-3 mt-2 text-center text-black">
              <h5 className="fw-800 color-secondary fs-5">Auto Insurance</h5>
              <p>
                {" "}
                Embarking on the journey of purchasing a car is more than just
                acquiring a vehicle
              </p>
            </div>
          </div>

          <div className="col-lg-4 col-md-4 col-12 p-2 d-flex flex-column px-5 px-md-3 mt-4   ">
            <div className=" d-flex justify-content-center">
              <img
                width={80}
                height={80}
                src={Bike}
                alt="step 3"
                srcSet={Bike}
              />
            </div>
            <div className="ms-3 mt-2 text-center text-black">
              <h5 className="fw-800 color-secondary fs-5">Bike Insurance</h5>
              <p> Embark on worry-free rides with our Bike Insurance</p>
            </div>
          </div>
        </div>
      </div>
      <div className="newColorGrad_bg">
        <div className="container py-5">
          <div className="row  justify-content-center">
            <div className="col-lg-3 col-12 text-center color-white ">
              <div
                style={{
                  color: "#ffffff",
                }}
                className="StepperCount pb-0 "
              >
                400K+
              </div>
              <div className="">
                <h6 className="text-capitalize fs-5 ">Customer Served</h6>
              </div>
            </div>

            <div className="col-lg-3 col-12 text-center color-white ">
              <div
                style={{
                  color: "#ffffff",
                }}
                className="StepperCount"
              >
                AA
              </div>
              <div className="">
                <h6 className="text-capitalize fs-5 ">PACRA Rating</h6>
              </div>
            </div>

            <div className="col-lg-3 col-12 text-center color-white ">
              <div
                style={{
                  color: "#ffffff",
                }}
                className="StepperCount"
              >
                300+
              </div>
              <div className="">
                <h6 className="text-capitalize fs-5">Employee Nationwide</h6>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="">
        <div className="container mt-5">
          <div className="row align-items-center py-5 ">
            <div className="col-lg-7 col-12 text-center text-md-start  ">
              <h2 className="fw-bolder fs-1 pb-4">
                Get the FameWheels <br />{" "}
                <span className="color-secondary"> Mobile App</span>
              </h2>
              <div className="d-flex justify-content-center justify-content-md-start  ">
                <a
                  href="https://play.google.com/store/apps/details?id=com.famewheels"
                  target="_blank"
                >
                  <img
                    style={{ height: 40, objectFit: "contain" }}
                    className="img-fluid"
                    src={GooglePlay}
                    alt="Famewheels Mobile App"
                    srcSet=""
                  />
                </a>
                <a
                  href="https://apps.apple.com/pk/app/famewheels-car-live-bidding/id6475592948"
                  target="_blank"
                >
                  <img
                    style={{ height: 40, objectFit: "contain" }}
                    className="img-fluid mx-2"
                    src={AppleStore}
                    alt="Famewheels Apple App"
                    srcSet=""
                  />
                </a>
              </div>
            </div>

            <div className="col-lg-5 text-center text-md-end mt-5 mt-md-0 ">
              <img
                src={FWMobile}
                className="img-fluid w-75"
                style={{ height: 320, objectFit: "contain" }}
                alt="Famewheels Live Bidding"
                srcSet=""
              />
            </div>
          </div>
        </div>
      </div>

      <Modal
        open={isOpen}
        onClose={onClose}
        disableAutoFocus={true}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        className="Fw-popups"
      >
        <Box className="sm-modal position-relative p-4">
          <div className="modalBody_area successBox  px-2 text-center">
            <h3 className="pt-2 mb-5">Select Your Vehicle</h3>

            <div className="container">
              <div className="col-12">
                <div className="mb-3 text-start">
                  <label for="vehicleMake" className="form-label">
                    Select Make
                  </label>
                  <select
                    className="form-select"
                    id="vehicleMake"
                    aria-label="Default select example"
                    required
                    value={makeName}
                    onChange={handleMakeChange}
                  >
                    <option selected value=" ">
                      Select Make
                    </option>
                    {make &&
                      make.map((item) => (
                        <option key={item.makeId} value={item.makeName}>
                          {item.makeName}
                        </option>
                      ))}
                  </select>
                  <div id="CityHelp" className="form-text">
                    Mention your vehicle's make (e.g. Honda)
                  </div>
                </div>
              </div>

              {makeName !== null && (
                <div className="col-12">
                  {makeId && getModel?.length > 0 ? (
                    <div className="mb-3 text-start">
                      <label for="vehicleModel" className="form-label">
                        Model
                      </label>
                      <select
                        className="form-select"
                        id="vehicleModel"
                        aria-label="Default select example"
                        required
                        value={modelName}
                        onChange={handleModelChange}
                      >
                        <option selected value=" ">
                          Select {makeName && makeName} Model
                        </option>
                        {getModel &&
                          getModel.map((item) => (
                            <option key={item.modelId} value={item.modelName}>
                              {item.modelName}
                            </option>
                          ))}
                      </select>

                      <div id="CityHelp" className="form-text">
                        Mention your vehicle's Model (e.g. Civic)
                      </div>
                    </div>
                  ) : (
                    <div className="mb-3 text-start">
                      <label for="vehicleModel" className="form-label">
                        Model
                      </label>
                      <select
                        className="form-select border-danger"
                        id="vehicleModel"
                        aria-label="Default select example"
                        required
                        disabled
                      >
                        <option selected value=" ">
                          Select {makeName && makeName} Model
                        </option>
                      </select>

                      <div id="CityHelp" className="form-text text-danger">
                        Select make first
                      </div>
                    </div>
                  )}
                </div>
              )}
              {modelName && modelName !== "" && (
                <div className="col-12">
                  {makeId && modelName !== " " && modelYear?.length > 0 ? (
                    <div className="mb-3 text-start">
                      <label for="vehicleYear" className="form-label">
                        Year
                      </label>
                      <select
                        className="form-select"
                        id="vehicleYear"
                        aria-label="Default select example"
                        required
                        value={yearName}
                        onChange={handleYearChange}
                      >
                        <option selected value=" ">
                          Select Year
                        </option>
                        {modelYear &&
                          modelYear.map((item) => (
                            <option key={item.yearId} value={item.year}>
                              {item.year}
                            </option>
                          ))}
                      </select>

                      <div id="CityHelp" className="form-text">
                        Mention your vehicle's Year (e.g. 2018)
                      </div>
                    </div>
                  ) : (
                    <div className="mb-3">
                      <label for="vehicleYear" className="form-label">
                        Year
                      </label>
                      <select
                        className="form-select border-danger"
                        id="vehicleYear"
                        aria-label="Default select example"
                        required
                        disabled
                      >
                        <option selected value=" ">
                          Select Year
                        </option>
                      </select>
                      <div id="CityHelp" className="form-text text-danger">
                        Select Model first
                      </div>
                    </div>
                  )}
                </div>
              )}
            </div>

            <Button
              onClick={handleConfirmVehicle}
              variant="contained"
              className="py-2 px-4 mt-3 color-white fw-700 bgSecondary  text-capitalize"
            >
              Confirm
            </Button>
          </div>
        </Box>
      </Modal>
      <Modal
        open={successOpen}
        onClose={onClose}
        disableAutoFocus={true}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        className="Fw-popups"
      >
        <Box className="sm-modal position-relative p-4">
          <div className="modalBody_area successBox  px-2 text-center">
            <div className="container">
              <div className="modalBody_area successBox  px-2 text-center ">
                <img
                  src={Confirm}
                  className="mb-4"
                  alt="confirm"
                  srcSet={Confirm}
                />
                <h4 className="pb-2 fs-3 ">Successful</h4>
                <p>We Will Get In Touch With You Shortly</p>
              </div>
            </div>
          </div>
        </Box>
      </Modal>
    </>
  );
}
